import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../../../../../ParticipantsStore/Types';
import AddParticipantStore from '../../../../../../Store';
import NoParticipants from './NoParticipants';
import Participants from './Participants';

export interface Props {
  store: AddParticipantStore;
  newParticipants: ReadonlyArray<ParticipantResource>;
}

function ParticipantsList({ store, newParticipants }: Props) {
  return fromEmpty(newParticipants)
    .map((participants) => <Participants participants={participants} store={store} />)
    .getOrElse(() => <NoParticipants submit={store.submit} />);
}

export default observer(ParticipantsList);
